import React from 'react';
import { times } from 'lodash';
import { TextLoading } from '../../../../../../../CommonComponents/OPL/Text/Text.loading';
import { useIsEmbeddedMobile } from '../../../../../../../_hooks/useIsEmbeddedMobile';

export const TableLoading = () => {
  const isEmbeddedMobile = useIsEmbeddedMobile();

  const cellsCount = isEmbeddedMobile ? 2 : 7;

  return (
    <tr>
      {times(cellsCount).map(key => (
        <td key={key}>
          <TextLoading height="h4" width="100%" />
        </td>
      ))}
    </tr>
  );
};
